<template>
  <!-- 下拉选择 -->
  <div class="SelectBox">
    <div v-if="!data.answered">
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box" :title="selectedLabel">
        <el-select
          ref="select"
          v-model="value"
          placeholder="请选择"
          popper-class="topic-select-box-dropdown"
          @visible-change="onVisibleChange">
          <el-option
            v-for="item in data.itemList"
            :key="item.itemNo"
            :label="labelTxt(item.itemDes)"
            :value="item.itemId"
            :title="labelTxt(item.itemDes)">
            <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
              <span>{{o.txt}}</span>
            </div>
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 有答案后 -->
    <div v-else>
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box" :title="selectedLabel">
        <el-select
          ref="select"
          v-model="value"
          :disabled="disabledBol"
          placeholder="请选择"
          popper-class="topic-select-box-dropdown"
          @visible-change="onVisibleChange">
          <el-option
            v-for="item in data.itemList"
            :key="item.itemNo"
            :label="labelTxt(item.itemDes)"
            :value="item.itemId"
            :title="labelTxt(item.itemDes)">
            <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
              <span>{{o.txt}}</span>
            </div>
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>
const SELECT_WIDTH = 352
const DROPDOWN_MAX_WIDTH = 704

export default {
  name: 'SelectBox',
  props: {
    data: Object,
    disabledBol: Boolean     // 是否disabled
  },
  computed: {
    answerObj () {
      let obj
      if (!this.value) {
        obj = {
          msg: '请选择后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.value
        }
      }
      return obj
    },
    // 选中项完整文案，用于输入框 hover 查看
    selectedLabel () {
      if (!this.value || !this.data || !this.data.itemList) return ''
      const matched = this.data.itemList.find(item => item.itemId === this.value)
      return matched ? this.labelTxt(matched.itemDes) : ''
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    // 处理选项文字
    labelTxt (val) {
      try {
        let arr = JSON.parse(val)
        return (arr && arr[0] && arr[0].txt) || ''
      } catch (e) {
        return ''
      }
    },
    onVisibleChange (visible) {
      if (!visible) return
      this.$nextTick(() => {
        this.fitDropdownWidth()
      })
    },
    // 选项宽：不足选择框时等于选择框；超出时放大，最大 704px
    fitDropdownWidth () {
      const select = this.$refs.select
      if (!select || !select.$el) return
      const selectWidth = select.$el.offsetWidth || SELECT_WIDTH
      let popperEl = select.$refs.popper
      if (popperEl && popperEl.$el) popperEl = popperEl.$el
      if (!popperEl) {
        popperEl = document.querySelector('.topic-select-box-dropdown')
      }
      if (!popperEl) return

      const items = popperEl.querySelectorAll('.el-select-dropdown__item')
      const probe = document.createElement('div')
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font-size:14px;line-height:34px;padding:0 20px;box-sizing:border-box;'
      document.body.appendChild(probe)
      let maxContentWidth = 0
      items.forEach(item => {
        probe.textContent = (item.textContent || '').replace(/\s+/g, ' ').trim()
        maxContentWidth = Math.max(maxContentWidth, probe.offsetWidth)
      })
      document.body.removeChild(probe)

      const width = Math.min(DROPDOWN_MAX_WIDTH, Math.max(selectWidth, maxContentWidth))
      popperEl.style.width = width + 'px'
      popperEl.style.minWidth = selectWidth + 'px'
      popperEl.style.maxWidth = DROPDOWN_MAX_WIDTH + 'px'
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.value = this.data.answered
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<!-- 下拉层挂到 body，需非 scoped -->
<style lang="scss">
.topic-select-box-dropdown {
  max-width: 704px;
  .el-select-dropdown__wrap {
    max-height: 280px;
  }
  .el-select-dropdown__item {
    height: auto !important;
    min-height: 34px !important;
    line-height: 20px !important;
    white-space: normal !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    padding-top: 7px;
    padding-bottom: 7px;
    div,
    span {
      display: block;
      max-width: 100%;
      white-space: normal !important;
      word-break: break-all !important;
      word-wrap: break-word !important;
      line-height: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
.SelectBox{
  .SelectBox_title{
    margin-top: 24px;
    font-size: 16px;
    line-height: 22px;
  }
  .box{
    width: 352px;
    margin-top: 8px;
    /deep/ .el-input__inner {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/select-box.vue